// StripeRedirect.js
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function StripeRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const payment = query.get("payment");

    // Give app a moment to load before redirecting
    setTimeout(() => {
      navigate(`/authorportal/letsgetstarted?payment=${payment}`, { replace: true });
    }, 500); // Optional: delay to allow auth/session to load
  }, [location, navigate]);

  return (
    <div className="h-screen flex items-center justify-center bg-bookish-cream text-bookish-purple">
      <p className="text-lg sm:text-xl font-serif">Redirecting you back to your setup...</p>
    </div>
  );
}
